import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { menuEnter, menuSetActive, menuExit } from 'actions';
import NavNarrow from './NavNarrow';
import NavWide from './NavWide';
import { SmallScreen } from 'utils/responsive-mq';

const Nav = (props) => (
	<SmallScreen>
		{(match) => {
			return (match)? 
				<NavNarrow {...props} /> : 
				<NavWide {...props} />;
		}}
	</SmallScreen>
)
Nav.propTypes = {
	title: PropTypes.string.isRequired,
	menus: PropTypes.array.isRequired,
	open: PropTypes.bool.isRequired,
	current: PropTypes.string,
	onMenuEnter: PropTypes.func,
	onMenuSetActive: PropTypes.func,
	onMenuExit: PropTypes.func
}
const mapStateToProps = (state) => {
	return {
		title: state.config.nav_title,
		menus: state.menu.submenus,
		open: state.menu.open,
		current: state.menu.current,
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		onMenuEnter: () => {
			dispatch( menuEnter() )
		},
		onMenuSetActive: (levels) => {
			dispatch( menuSetActive(levels) )
		},
		onMenuExit: () => {
			dispatch( menuExit() )
		},
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(Nav);


// WEBPACK FOOTER //
// ./src/components/Header/Nav/Nav.jsx